import { Injectable, Signal, computed, signal } from '@angular/core';
import { en } from '../../i18n/en';
import { nl } from '../../i18n/nl';
import type { Translations } from '../../i18n/translations.model';

export type Language = 'en' | 'nl';

const TRANSLATIONS: Record<Language, Translations> = { en, nl };

@Injectable({ providedIn: 'root' })
export class TranslationService {
    readonly currentLang = signal<Language>('nl');

    readonly translations: Signal<Translations> = computed(
        () => TRANSLATIONS[this.currentLang()],
    );

    setLanguage(lang: Language): void {
        this.currentLang.set(lang);
    }

    translate(key: string, params?: Record<string, string>): string {
        const keys = key.split('.');
        let value: unknown = this.translations();

        for (const k of keys) {
            if (typeof value !== 'object' || value === null) {
                return key;
            }
            value = (value as Record<string, unknown>)[k];
        }

        if (typeof value !== 'string') {
            return key;
        }

        if (!params) {
            return value;
        }

        return Object.entries(params).reduce(
            (result, [paramKey, paramValue]) => result.split(`{{${paramKey}}}`).join(paramValue),
            value,
        );
    }
}
